import { useEffect, useState } from 'preact/hooks';
import { useHud } from '../context.js';

/**
 * Resolve a vault path to something an `<img src>` can load.
 *
 * Returns the plain URL immediately, then upgrades to a credentialed data URL
 * if the adapter provides one. Rendering the plain URL first keeps the local
 * dev path synchronous and flicker-free; the upgrade is what makes private
 * GitHub repos work at all.
 */
export function useAsset(path: string, remote: boolean): string {
  const { assetUrl, assetDataUrl } = useHud();
  const [resolved, setResolved] = useState(() => (remote ? path : assetUrl(path)));

  useEffect(() => {
    if (remote) {
      setResolved(path);
      return;
    }
    if (!assetDataUrl) {
      setResolved(assetUrl(path));
      return;
    }

    let cancelled = false;
    assetDataUrl(path)
      .then((url) => {
        if (!cancelled) setResolved(url);
      })
      .catch(() => {
        // Leave the plain URL in place; a broken image is a clearer symptom
        // than a blank tile.
      });

    return () => {
      cancelled = true;
    };
  }, [path, remote, assetUrl, assetDataUrl]);

  return resolved;
}
